<template lang="pug">
.cp-news
  .banner
    p.p1 新闻动态
    p.p2 NEWS
  .main-wrap
    .w
      .list
        .item(v-for="item in currentList")
          .col.date(v-if="!isMobile")
            h3 {{item.date.split('-')[1]}}-{{item.date.split('-')[2]}}
            span {{item.date.split('-')[0]}}
          img.col.img(:src="'static/images/news/'+item.img")
          .info.col
            a.title(v-if="isMobile", :href="item.url") {{item.title}}
            a.title(v-else, :href="item.url", target="_black") {{item.title}}
            p.desc(v-if="!isMobile") {{item.desc}}
            p.source
              span.mobile-source {{item.source}}
              span.mobile-date(v-if="isMobile") {{item.date}}
      .page
        span.btn-prev(:class="{disable: !canPrev}", @click="handelPrev") <
        span(v-for="n in pageCount", :class="{active: n == currentPage}", @click="handelPage(n)") {{n}}
        span.btn-next(:class="{disable: !canNext}", @click="handelNext") >
</template>

<script>
export default {
  data () {
    return {
      list: DB.newsList,
      count: 0,
      pageCount: 1,
      currentPage: 1,
      pageSize: DB.newsPageSize,
    }
  },
  computed: {
    currentList () {
      const list = this.list
      const start = this.pageSize * (this.currentPage - 1)
      const end = this.pageSize * (this.currentPage)

      return this.list.slice(start, end)
    },
    canPrev () {
      return this.currentPage > 1
    },
    canNext () {
      return this.currentPage < this.pageCount
    }
  },
  methods: {
    handelPrev () {
      if (this.canPrev) this.currentPage--
    },
    handelNext () {
      if (this.canNext) this.currentPage++
    },
    handelPage (n) {
      this.currentPage = n
    },
    getData () {
      const list = DB.newsList
      this.count = list.length
      this.pageCount = Math.ceil(this.count / this.pageSize)
    }
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="stylus">
@import 'config'
.cp-news
  .banner
    background url(../assets/web/banner-news.jpg) center
    background-size auto 100%
    width 100%
    height 240px
    color #fff
    font-size 18px
    display flex
    justify-content center
    align-items center
    flex-direction column
    .p1
      font-size 40px
  .main-wrap
    background-color #f5f7f9
    padding 45px 0
    .w
      padding 30px
      background-color #fff
    .list
      .item
        border-bottom 1px solid #dbd9d9
        transition 1s all
        overflow hidden
        padding 20px 0
        &:hover
          background #f5f7f9
          border-bottom-color #f5f7f9
        .col
          float left
          margin-left 30px
        .date
          padding-top 60px
          h3
            font-size 30px
            color #242323
          span
            font-size 14px
            color #666
        .img
          width 187px
          height 140px
        .info
          width 700px
          .title
            display block
            color #242323
            font-size 20px
            padding-bottom 10px
            &:hover
              color #3ec1bd
          .desc
            font-size 14px
            color #666
          .source
            margin-top 5px
            text-align right
            color #999
    .page
      text-align center
      margin-top 60px
      span
        display inline-block
        width 20px
        height 20px
        line-height 20px
        margin 0 5px
        color #999
        font-size 14px
        cursor pointer
        user-select none
        // &:hover
        //   text-decoration underline
        &.active
          color #3bc0bc
          cursor default
      .btn-prev,
      .btn-next
        background #3bc0bc
        color #fff
        font-size 14px
        &.disable
          background #ccc
          cursor not-allowed
.is-mobile
  .cp-news
    .banner
      height r(100)
      background-image url(../assets/mobile/banner-news.jpg)
      .p1
        font-size r(30)
      .p2
        font-size r(20)
    .main-wrap
      padding 0
      .w
        padding 0
        padding 0
      .list
        .item
          padding r(20) 0
          .col
            margin-left r(30)
          .img
            width r(180)
            height r(140)
          .info
            position relative
            width r(480)
            min-height r(140)
            .title
              font-size r(30)
              padding-bottom r(30)
            .source
              position absolute
              bottom 0
              left 0
              width 100%
              overflow hidden
              line-height r(30)
              font-size r(20)
              .mobile-source
                float left
              .mobile-date
                float right
</style>



// WEBPACK FOOTER //
// src/views/news.vue